import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { RiskLevelEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/levels' };

export const riskLevelsActions = createRestActions<RiskLevelEntity>(actionConfig);

export const RiskLevelsStore = createRestStore<RiskLevelEntity>({
  name: 'risk-levels-store',
  actions: riskLevelsActions,
  actionConfig,
  containerDisplayName: 'risk-levels-container',
  onInitAction: null,
});

export const useRiskLevelsData = createDataHook(RiskLevelsStore);
export const useRiskLevelsIsLoading = createLoadingHook(RiskLevelsStore);
export const useRiskLevelsActions = createActionsHook(RiskLevelsStore);
export const didRiskLevelsMutationFail = createMutationFailedCheck(actionConfig.resourcePath);